<template>
    <div>

        <nav class="texte-center">
            <div class="flex nav" id="tabs">
                <a class="no-underline hover:no-underline text-grey-darkest preactive"
                    href="#project" ref="project" aria-controls="project" role="tab" data-toggle="tab" @click="callTabs('project')">
                    Project
                </a>
                <a class="no-underline hover:no-underline text-grey-darkest"
                    href="#contact" aria-controls="contact" role="tab" data-toggle="tab" @click="callTabs('contact')">
                    Contact
                </a>
                <a class="no-underline hover:no-underline text-grey-darkest"
                   href="#dash-report" aria-controls="dash-report" role="tab" data-toggle="tab" @click="callTabs('dash-report')">
                    Dash Report
                </a>
            </div>
        </nav>

        <div class="tab-content flex">
            <div v-if="currentTabName == 'project'" role="tabcard" class="tab-pane active w-5/6" id="project">
                <keep-alive>
                    <sales-behaviors>
                    </sales-behaviors>
                </keep-alive>
            </div>
            <div v-if="currentTabName == 'contact'" role="tabcard" class="tab-pane w-5/6" id="contact">
                <keep-alive>
                    <contact-sales-behaviors>
                    </contact-sales-behaviors>
                </keep-alive>
            </div>
            <div v-if="currentTabName == 'dash-report'" role="tabcard" class="tab-pane w-5/6" id="dash-report">
                <keep-alive>
                    <dashboard-report>
                    </dashboard-report>
                </keep-alive>
            </div>
        </div>

    </div>
</template>

<script>

    import DashboardReport from "./dashboard-report.vue";

    export default {
        name: 'sales-behaviors-tabs',
        components: {DashboardReport},

        data() {
            return {
                currentTabName: 'project',
            }
        },

        methods: {

            callTabs(tab){
                this.$refs.project.classList.remove('preactive');
                this.currentTabName = tab;
            },
        },
    }
</script>

<style scoped>
    #tabs a {

        background: #d9e0e0;
        color: black;
        border-radius: 5px;
        padding: 3px 25px 3px 25px;
    }
    #tabs a.active, #tabs a.preactive{

        background: #38B1AF !important;
        color: white !important;
        border-radius: 5px !important;
        padding: 3px 25px 3px 25px !important;
    }
</style>
